export default "__VITE_ASSET__Cafk3vFW__"